<template>
    <div class="home">
        <HelloWorld  />

        <RouteList :routen="BPRoutesComputed"></RouteList>

        <HomeDescription></HomeDescription>
    </div>
</template>

<script type="text/babel">
    import HelloWorld from '../components/HelloWorld.vue'
    import RouteList from '../components/RouteList.vue'
    import HomeDescription from "../components/HomeDescription";

    export default {
        name: 'homeView',

        components: {
            HomeDescription,
            HelloWorld, RouteList
        },
        computed: {
            BPRoutesComputed: function () {
                return this.$root.BPRoutes;
            },

        }

    }
</script>
